import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

export const useSidebarLanguage = () => {
  const { i18n } = useTranslation()
  const storedLanguage = localStorage.getItem('language')
  const initialLanguage = storedLanguage || 'pl'
  const [language, setLanguage] = useState(initialLanguage)

  useEffect(() => {
    i18n.changeLanguage(initialLanguage).then()
    dayjs.locale(initialLanguage)
  }, [i18n, initialLanguage])

  const changeLanguage = () => {
    const newLanguage = language === 'en' ? 'pl' : 'en'
    setLanguage(newLanguage)
    i18n.changeLanguage(newLanguage).then()
    dayjs.locale(newLanguage)
    localStorage.setItem('language', newLanguage)
  }

  return { changeLanguage }
}
